angular.module('wbDashboard').controller('AgreementControllerAurea', ['$scope', 'User', 'Auth', 'Display', '$window', 'Track', function ($scope, User, Auth, Display, $window, Track) {

    var user = User.getOverview().user;

    $scope.pageData = {
        name: (user.first_name + ' ' + user.last_name).trim(),
        sending: false,
        sent: false,
        apexAgree: false,
        frame: "agreement"
    };

    $scope.submit = function (sign) {
        $scope.pageData.sending = true;

        User.signAgreement('agree').then(function (response) {

            try {
                if (response.data.response.agreement.state == "agree") {
                    //TODO: get this to trigger the getOverview listener in display service
                    //can't trigger before welcome pages though
                    //User.getOverview().user.flags.signup_agreement_signed = 1;
                    //User.getOverview().user.agreements = [response.data.response.agreement];

                    //all done, will not go to welcome pages if they signed agreement in dashboard
                    // $scope.forceWelcome();
                    $scope.pageData.sent = true;
                    User.retrieveOverview(true);
                    $scope.$state.go('base.overview');

                    Track.send("Sign Agreement", "sign-up", {});
                }
            } catch (err) {
                $window.location.reload();
            }


        }).finally(function (response) {
            $scope.pageData.sending = false;
        });
    };

}]);
